<template>
  <TransactionTemplate
    :getHeaderToolbar="getHeaderToolbar"
    :screenJson="getScreenJson"
    :headerScreenJson="getHeaderScreenJson"
    :setLoading="setLoading"
    :localDataGrid="false"
    :backButtonRoute="getBackButtonRoute()"
    ref="work-order-detail"
    :isLoaded="loaded"
    :paging="false"
    v-if="!reload"
    :tabs="{}"
  />
</template>

<script>
import TransactionTemplate from "../../templates/transaction";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
  },
  data() {
    return {
      loaded: false,
      reload: false,
      setLoading: false,
      customerName: "",
      formDataModel: {},
    };
  },
  created() {
    this.loaded = true;
    this.customerName = this.baseView.query.CustomerName;
  },
  methods: {
    getBackButtonRoute() {
      return `/sales-order-profit-enquiry/${this.baseView.query.SalesOrderCode}`;
    },
    postProcess(data) {
      data.forEach((rowData) => {
        // rowData.Variance = rowData.OriginalCost - rowData.ActualCost; // Added to the API Data Model.
        if (rowData.IsPrimeCostItem) {
          rowData.ItemDescription1 = rowData.WorkOrderComment;
        }
      });

      this.$store.dispatch("dataContext/setReviewDataSource", data);

      return data;
    },
  },
  computed: {
    getFooterItems() {
      return [
        {
          screenField: "SalesUMQty",
          dataField: "WorkOrderActualQty",
          location: "left",
          label: "Item Count",
          value: 0,
        },
        {
          dataField: "OriginalCost",
          screenField: "NetLineTotal",
          location: "right",
          value: 0,
          format: "Decimal-16-2C",
          label: `Original Cost Total`,
        },
        {
          dataField: "ActualCost",
          screenField: "NetLineTotal",
          location: "right",
          value: 0,
          format: "Decimal-16-2C",
          label: `Actual Cost Total`,
        },
        {
          dataField: "Variance",
          screenField: "NetLineTotal",
          location: "right",
          value: 0,
          format: "Decimal-16-2C",
          label: "Variance",
        },
      ];
    },
    getHeaderToolbar() {
      return {
        headerToolbar: {
          screenName: "Work Order Detail",
          pdf: false,
          audit: false,
          status: true,
          notes: false,
          save: false,
          toolbarFormItems: [
            {
              dataField: "CustomerName",
              width: 500,
              label: { text: "Customer Name", visible: false },
              readOnly: true,
              allowEdit: false,
            },
          ],
        },
      };
    },
    getScreenJson() {
      return {
        title: "Sales Quote Detail",
        endpoint: {
          primary: "SalesOrderProfitEnquiryWOSummary",
          filter: `WorkOrderCode eq ${this.baseView.id} and SalesOrderCode eq ${this.baseView.query.SalesOrderCode}`,
        },
        gridData: {
          gridOptions: {
            dataSource: {
              allowGrouping: false,
              serverPaging: true,
            },
            dataGridViews: [
              {
                label: "Details",
                value: "details",
                default: true,
                dataSource: {
                  endpoint: "SalesOrderProfitEnquiryWODetail",
                  filter: [
                    ["WorkOrderCode", "=", parseInt(this.baseView.id)],
                    [
                      "SalesOrderCode",
                      "=",
                      parseInt(this.baseView.query.SalesOrderCode),
                    ],
                  ],
                  serverPaging: true,
                  allowGrouping: false,
                  postProcessCallback: this.postProcess,
                },
                columns: [
                  {
                    screenField: "Item",
                    dataField: "ItemCode",
                    label: "Product/Account",
                    cellTemplateRecord: {
                      primary: [
                        {
                          dataField: "ItemDescription1",
                        },
                      ],
                      secondary: [
                        {
                          dataField: "ItemCode",
                        },
                      ],
                    },
                    allowEditing: false,
                    allowSearch: false
                  },
                  {
                    visible: false,
                    allowSearch: true,
                    dataField: "ItemCode"
                  },
                  {
                    visible: false,
                    allowSearch: true,
                    dataField: "ItemDescription1"
                  },
                  {
                    dataField: "SalesAmountExTax",
                    caption: "Sales Amount Ex Tax",
                    format: "'$' ##,###,###,###,##0.00",
                    width: 150,
                  },
                  {
                    screenField: "SalesUMQty",
                    dataField: "WorkOrderOriginalQty",
                    label: "Original Qty",
                    gridDataField: "WorkOrderOriginalQty",
                    editorOptions: {
                      format: "##,###,###,###,##0.00",
                    },
                    width: 150,
                    allowSearch: false,
                  },
                  {
                    screenField: "SalesUMQty",
                    dataField: "WorkOrderActualQty",
                    label: "Actual Qty",
                    gridDataField: "WorkOrderActualQty",
                    editorOptions: {
                      format: "##,###,###,###,##0.00",
                    },
                    width: 150,
                    allowSearch: false,
                  },
                  {
                    dataField: "WorkOrderOriginalUnitCost",
                    label: "Original Unit",
                    format: "'$' ##,###,###,###,##0.0000",
                    width: 150,
                    allowSearch: false,
                  },
                  {
                    dataField: "OriginalCost",
                    label: "Original Cost",
                    format: "'$' ##,###,###,###,##0.00",
                    width: 150,
                    allowSearch: false,
                  },
                  {
                    dataField: "WorkOrderActualUnitCost",
                    label: "Actual Unit",
                    format: "'$' ##,###,###,###,##0.0000",
                    width: 150,
                    allowSearch: false,
                  },
                  {
                    dataField: "ActualCost",
                    label: "Actual Cost",
                    format: "'$' ##,###,###,###,##0.00",
                    width: 150,
                    allowSearch: false,
                  },
                  {
                    screenField: "Variance",
                    dataField: "Variance",
                    label: "Variance",
                    format: "Decimal-16-2C",
                    width: 150,
                    allowSearch: false,
                  },
                  {
                    dataField: "SalesOrderStatus",
                    label: "",
                    cellTemplate: "Status",
                    fixed: false,
                  },
                ],
              },
            ],
          },
          toolbar: {
            search: true,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: false,
            review: false,
            audit: false,
          },
          columns: [],
        },
        footerData: {
          footerItems: this.getFooterItems,
        },
      };
    },
    getHeaderScreenJson() {
      return {
        headerData: {
          title: {
            primary: {
              primary: {
                dataField: undefined,
                text: `Work Order # ${this.baseView.id}`,
              },
            },
            secondary: {
              dataField: "CustomerName",
            },
          },
          formItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      dataField: "CustomerName",
                      allowUpdate: false,
                      label: {
                        text: "Customer",
                      },
                    },
                    {
                      dataField: "SalesOrderType",
                      allowUpdate: false,
                      label: {
                        text: "SO Type",
                      },
                    },
                    {
                      dataField: "SalesRepName",
                      allowUpdate: false,
                      label: {
                        text: "Rep",
                      },
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      dataField: "SalesOrderCode",
                      allowUpdate: false,
                      label: {
                        text: "Sales Order",
                      },
                    },
                    {
                      dataField: "WorkOrderCode",
                      allowUpdate: false,
                      label: {
                        text: "Works Order",
                      },
                    },
                    {
                      dataField: "SalesQuoteCode",
                      allowUpdate: false,
                      label: {
                        text: "Sales Quote",
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      };
    },
  },
};
</script>
